import React from 'react';
import 'twin.macro';
import { useCarnetsDeNotesTrash } from '@teetsh/app/src/containers/UserSettings/Trash/CarnetsDeNotes/useCarnetsDeNotesTrash';
import { useRestoreCarnetDeNote } from '@teetsh/app/src/containers/UserSettings/Trash/CarnetsDeNotes/useRestoreCarnetDeNote';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableCarnetDeNotes } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';

export function CarnetsDeNotesRestorableList() {
  const { data = [] } = useCarnetsDeNotesTrash();
  const restore = useRestoreCarnetDeNote();

  return (
    <RestorableList<RestorableCarnetDeNotes> items={data} restore={restore} />
  );
}
